import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  card_round: {
    borderRadius: theme.spacing(2),
  },
}));

export default useStyles;
